// 曝光逻辑
// 首页flash sale和New Arrival产品曝光
function transverse_product_setupObserver(home_slideId) {
    const observerOptions = {
      root: null, // 使用 viewport 作为根
      rootMargin: '0px', // 根边距
      threshold: 0.1 // 10% 的可见面积
    };
  
    const transverse_product_observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const productElement = entry.target;
          const productId = productElement.dataset.productId;
          const transverse_product_title = productElement.querySelector('.ptit')?.innerText;
          const transverse_product_price = productElement.querySelector('.Price--highlight .money')?.innerText;
          const transverse_product_index = productElement.parentElement.getAttribute('data-index');
  
          trackExposure(productId, transverse_product_title,transverse_product_index, transverse_product_price, home_slideId);
  
          // 停止观察以防止重复曝光
          transverse_product_observer.unobserve(productElement);
        }
      });
    }, observerOptions);
  
    // 获取模块中的所有产品元素
    const productElements = document.querySelectorAll(`.${home_slideId} .Carousel__Cell .ProductItem`);
    
    // 为每个产品元素添加观察
    productElements.forEach(product => {
      transverse_product_observer.observe(product);
    });
  }
  
  function trackExposure(productId, product_title,product_index,product_price, home_slideId) {
      console.log(`曝光产品 [模块 ${home_slideId}]:`, {
          id: productId,
          image: product_title,
          alt: product_price,
          index: product_index
      });
      if(home_slideId =='home_slide1'){
          DataLyer_push_product('HomePage_Flash Sale',product_title,productId,product_price,'todays-deals',product_index);
      }
  
    // 在这里添加其他曝光处理逻辑，例如发送 AJAX 请求
  }
  // 设置观察器
  transverse_product_setupObserver('home_slide1');
  transverse_product_setupObserver('home_slide2');
  // 首页flash sale和New Arrival产品曝光结束
  
  // banner曝光处理
// 存储已曝光的 Slide ID，防止重复曝光
const exposedSlides = new Set();
// 获取所有轮播 Slide
const banner_slides = document.querySelectorAll('.Slideshow__Slide');

// 曝光逻辑处理函数
function banner_handleExposure(slideIndex, banner_imgSrc, banner_imgAlt) {
  // 替换为你的曝光逻辑，如埋点、数据上报等
  console.log(`banner曝光处理: ${slideIndex}`,banner_imgSrc,banner_imgAlt);
  DataLyer_push_banner(banner_imgAlt,banner_imgSrc,slideIndex);
}
// 定义检查每个 Slide 的函数
function checkSlides() {
  banner_slides.forEach((slide) => {
    const opacity = window.getComputedStyle(slide).opacity;

    // 如果当前 Slide 的 opacity 为 1 且尚未曝光过
    if (opacity === '1' && !exposedSlides.has(slide.dataset.index)) {
      var banner_imgSrc = '';
      var banner_imgAlt = '';
      if(jQuery(window).width()<768){
        banner_imgSrc = slide.querySelector('.m_babner img')?.getAttribute('src') || '';
        banner_imgAlt = slide.querySelector('.m_babner img')?.getAttribute('alt') || '';
      }else{
        banner_imgSrc = slide.querySelector('.pc_babner img')?.getAttribute('src') || '';
        banner_imgAlt = slide.querySelector('.pc_babner img')?.getAttribute('alt') || '';
      }
      exposedSlides.add(slide.dataset.index); // 标记为已曝光
      banner_handleExposure(slide.dataset.index,banner_imgSrc,banner_imgAlt); // 执行曝光逻辑
    }
  });
}
// 定时轮询轮播状态，每500ms检查一次
setInterval(checkSlides, 500);
  // banner曝光处理结束
  

  // 金刚区图片曝光开始
  // 使用 Set 记录已曝光的图片 ID，避免重复曝光
  const jingang_exposedImages = new Set();
  
  // 创建 IntersectionObserver 实例
  const jingang_observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const item = entry.target; // 当前观察的滑块
  
      if (entry.isIntersecting) {
        // 获取当前滑块的 ID 和图片信息
        const jingang_slideIndex = item.dataset.index;
        const jingang_slideGroup = item.dataset.group;
        const jingang_imgSrc = item.querySelector('.CollectionItem__ImageWrapper img')?.getAttribute('src') || '';
        const promotion_name = item.querySelector('.CollectionItem__Link')?.innerText || '';
        const uniqueKey = `${jingang_slideGroup}-${jingang_slideIndex}`;
        if (!jingang_exposedImages.has(uniqueKey)) {
          jingang_exposedImages.add(uniqueKey); // 标记为已曝光
          // 执行曝光逻辑
          console.log(`金刚曝光图片 ${jingang_slideGroup}, index ${jingang_slideIndex}`);
          DataLyer_push_jingang(promotion_name,jingang_imgSrc,jingang_slideIndex);
        }
        jingang_observer.unobserve(item); // 停止监控，确保只曝光一次

      }
    });
  }, {
    root: null, // 视口为根元素
    threshold: 0.5 // 当图片 50% 可见时触发曝光
  });
  
  // 观察所有金刚区的图片
  const items = document.querySelectorAll('.Jingang_district .CollectionItem');
  items.forEach(item => jingang_observer.observe(item));
  // 金刚区曝光处理结束
  
  
  
  function DataLyer_push_banner(pic_name,pic_url,index) {
      console.log('当前图片的信息',pic_name,pic_url,index);
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "dle_view_promotion",
        dlv_ec: 'HomePage',
        dlv_ea: 'promoView',
        dlv_el: 'Top Banner',
        ecommerce: {
            items: [{
                item_name: pic_name,
                item_id: 'HomePage_Top Banner',
                promotion_id: 'HomePage_Top Banner',
                promotion_name: pic_name,
                creative_name: pic_url,
                creative_slot: index,
            }]
        }
      });
    }
    
    function DataLyer_push_jingang(pic_name,pic_url,index) {
      console.log('金刚区图片的信息',pic_name,pic_url,index);
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "dle_view_promotion",
        dlv_ec: 'HomePage',
        dlv_ea: 'promoView',
        dlv_el: 'King Kong',
        ecommerce: {
            items: [{
                item_name: pic_name,
                item_id: 'HomePage_King Kong',
                promotion_id: 'HomePage_King Kong',
                promotion_name: pic_name,
                creative_name: pic_url,
                creative_slot: index,
            }]
        }
      });
    }
    
    function DataLyer_push_product(collection_name,product_name,product_id,total_price,collection_id,index) {
      console.log('当前产品的信息',collection_name,product_name,product_id,total_price,collection_id,index);
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
      event: "dle_view_item_list",
      dlv_ec: 'HomePage',
      dlv_ea: 'productView',
      dlv_el: collection_name,
      ecommerce: {
        items: [{
          item_name: product_name,
          item_id: product_id,
          price: total_price,
          item_category: collection_id,
          item_list_name: collection_name,
          index: index,
          quantity: `1`,
          currency: 'USD',
        }]
      }
      });
    }
    $(function(){
      sessionStorage.removeItem('recommend_products_ids');
      sessionStorage.removeItem('recommend_card_id');
      sessionStorage.removeItem('recommend_products');
      window.intelligent_recommend( clientId , email);
    })
    // 监听滚动事件
    var scrollThreshold = 200; // 滚动的阈值，每滚动200像素调用一次函数
    var jiazai_num=0;
    // 滚动事件处理函数
    var lastScrollTop = $('#block-16595142387a8384ae-0').offset().top-1000;
    function scrollEventHandler() {
        if (!allowScrollHandler) {
            return;
        }
        // 获取当前滚动条的位置
       let scrollTop =  $(window).scrollTop();
        // 判断滚动的距离是否超过阈值，并且是向下滚动
            // 在这里编写原来的滚动事件处理逻辑
        if (scrollTop > lastScrollTop && (scrollTop - lastScrollTop) >= scrollThreshold) {
          jiazai_num+=1;
            // 调用需要执行的函数
            // 更新上次滚动的位置
            console.log('加载次数',jiazai_num);
            if(jiazai_num<8){
              lastScrollTop = $(window).scrollTop();
              window.intelligent_recommend( clientId , email);
            }
 
        }
    }